(function () {
    'use strict';

    angular
        .module('swif.fluid')
        .config(function ($routeProvider) {
            $routeProvider.when('/fluid/contracts/table_view', {
                templateUrl: 'partials/patrimoine/contracts_table_view.html',
                controller: 'PatrimoineContractsController',
                reloadOnSearch: false,
                resolve: {
                    data: ['swifFluidContractService', function (service) {
                        return service.resolveData();
                    }]
                }
            });
        })
        .service('swifFluidContractService', swifFluidContractService);

    function swifFluidContractService($q, swif, patrimoine) {
        var service = {};
        var patrimoine_contract = patrimoine.contract;

        service.resolveData = function () {

            return swif.route.check().then(function () {
                var filter = {};
                var deferred = $q.defer();

                swif.data.addExtraFilter(filter, 'is_fluid_meter', 'equipment_ids.product_product_id.categ_id.is_fluid_meter', '=', true);

                patrimoine_contract.createCollection(filter).then(function (collection) {
                    deferred.resolve({
                        title: 'Controls-Contracts',
                        contracts: collection
                    });
                });

                return deferred.promise;
            });

        };

        return service;
    }


})();
